<template>
  <v-container class="pa-0 info-cliente">
    <v-row justify="center" no-gutters>
      <v-col cols="11">
        <v-card elevation="10">
          <v-toolbar class="primaryGradient" dark flat tile :height="height">
            <v-toolbar-title class="titulo"
              >Bienvenido/a
              <span v-if="userLogged && user">
                {{ conv.capitalizeString(user.nombre) }}</span
              ></v-toolbar-title
            >
          </v-toolbar>
          <v-alert
            v-if="userLogged.b_castigado"
            outlined
            type="warning"
            dense
            prominent
            class="mb-0"
          >
            {{ userLogged.msg_castigado }}
          </v-alert>
          <v-toolbar
            color="secondary"
            :class="[userLogged.b_castigado ? 'mt-0 pt-0' : 'mt-4']"
            dark
            flat
            tile
            height="40px"
          >
            <v-icon left>mdi-account-details</v-icon>
            <v-toolbar-title class="cabecera"
              >Información Personal</v-toolbar-title
            >
          </v-toolbar>
          <v-row
            class="fill-height"
            align-content="center"
            justify="center"
            v-if="loading"
          >
            <v-col class="text-subtitle-1 text-center" cols="12">
              Cargando Datos
            </v-col>
            <v-col cols="6">
              <v-progress-linear
                color="primary"
                indeterminate
                rounded
                height="10"
              ></v-progress-linear>
            </v-col>
          </v-row>
          <div v-else>
            <v-list>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="primary"> mdi-map-marker </v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-subtitle>Dirección</v-list-item-subtitle>
                  <v-list-item-title
                    v-if="
                      user.direccion_particular &&
                      user.direccion_particular.trim().length > 0
                    "
                    >{{
                      conv.capitalizeString(user.direccion_particular)
                    }}</v-list-item-title
                  >
                  <v-list-item-title v-else>No hay registro</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="primary"> mdi-cellphone </v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-subtitle>Celular</v-list-item-subtitle>
                  <v-list-item-title
                    v-if="
                      user.Movil &&
                      user.Movil.trim().length > 0 &&
                      user.Movil !== '0'
                    "
                    >{{ user.Movil }}</v-list-item-title
                  >
                  <v-list-item-title v-else>No hay registro</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="primary"> mdi-phone </v-icon>
                </v-list-item-icon>

                <v-list-item-content class="py-0">
                  <v-list-item-subtitle>Teléfono</v-list-item-subtitle>
                  <v-list-item-title
                    v-if="
                      user.telefono_particular &&
                      user.telefono_particular.trim().length > 0 &&
                      user.telefono_particular !== '0'
                    "
                    >{{ user.telefono_particular }}</v-list-item-title
                  >
                  <v-list-item-title v-else>No hay registro</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <template v-if="sameEmail">
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="primary"> mdi-email </v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-subtitle>Correo</v-list-item-subtitle>
                    <v-list-item-title>
                      {{ user.email_persona }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <template v-else>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="primary"> mdi-email </v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-subtitle>Correo</v-list-item-subtitle>
                    <v-list-item-title
                      v-if="func.validateEmail(user.email_persona)"
                      >{{ user.email_persona }}</v-list-item-title
                    >
                    <v-list-item-title v-else
                      >No hay registro</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>

                <!-- <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="primary"> mdi-email-newsletter </v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-subtitle
                      >Correo de Notificaciones</v-list-item-subtitle
                    >
                    <v-list-item-title v-if="func.validateEmail(user.email)">{{
                      user.email
                    }}</v-list-item-title>
                    <v-list-item-title v-else
                      >No hay registro</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item> -->
              </template>
            </v-list>
            <informacion-bancaria :user="user" />
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="11">
        <v-row justify="center" align="stretch">
          <v-col v-for="product in products" :key="product.type">
            <v-card height="100px" elevation="10">
              <v-toolbar color="secondary" dark flat tile height="36px">
                <v-icon left>{{ product.icon }}</v-icon>
                <v-toolbar-title class="cabecera">{{
                  product.type
                }}</v-toolbar-title>
              </v-toolbar>
              <v-card-title class="productos pt-2 pb-0">
                <p class="flex text-center">
                  {{
                    product.status
                      ? conv.formatMonto(product.amount, true)
                      : "No posee"
                  }}
                </p>
              </v-card-title>
              <v-card-subtitle
                class="flex text-center"
                v-if="product.status != '0' && product.type === 'Créditos'"
              >
                Total Adeudado
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="11" v-if="!publicidadesSlider">
        <skeleton-noticias />
      </v-col>
      <v-col
        cols="11"
        v-if="publicidadesSlider && publicidadesSlider.length > 0"
      >
        <publicidades-fijas />
      </v-col>
    </v-row>
    <campania-dialog v-if="dialogoCampania" />
    <mora-dialog v-if="dialogoMora" />
    <mora-dialog v-if="dialogoMoraAvalado" :type="2" />
    <dialogo-publicidad v-if="dialogoPublicidades" />
  </v-container>
</template>
<script>
import auth from "@/services/auth";
import socio from "@/services/socio";
import conv from "@/utility/conversores";
import funciones from "@/utility/funciones";
import CampaniaDialog from "@/components/inicio/CampaniaDialog.vue";
import MoraDialogVue from "@/components/inicio/MoraDialog.vue";
import DialogoPublicidad from "@/components/inicio/DialogoPublicidad.vue";
import PublicidadesFijas from "@/components/inicio/PublicidadesFijas.vue";
import { mapActions, mapState } from "vuex";
import SkeletonNoticias from "@/components/inicio/SkeletonNoticias.vue";
import InformacionBancaria from "@/components/inicio/InformacionBancaria.vue";

export default {
  metaInfo: { title: "Inicio", shouldUpdate: () => false },
  components: {
    CampaniaDialog,
    "mora-dialog": MoraDialogVue,
    DialogoPublicidad,
    PublicidadesFijas,
    SkeletonNoticias,
    InformacionBancaria
  },
  data: function () {
    return {
      user: null,
      products: [
        { type: "Créditos", status: false, amount: 0, icon: "mdi-credit-card" },
        { type: "Cuenta capital", status: false, amount: 0, icon: "mdi-cash" }
      ],
      loading: true
    };
  },
  methods: {
    ...mapActions(["setPublicidades"]),
    async setProductos() {
      if (this.user.creditos > 0) {
        await socio
          .getCreditos("")
          .then((response) => {
            let creditos = response.data;
            if (creditos.length > 0) {
              this.products[0].status = this.user.creditos > 0;
              let montoFinal = 0;
              creditos.forEach((credito) => {
                montoFinal += credito.saldo;
              });
              this.products[0].amount = montoFinal;
            }
          })
          .catch((error) => console.error(error));
      }
      if (this.user.cuenta_capital > 0) {
        await socio
          .getCuentaCapital()
          .then((response) => {
            let cuenta = response.data;
            if (response.data) {
              this.products[1].status = true;
              this.products[1].amount = cuenta.saldo;
            }
          })
          .catch((error) => console.error(error));
        //traer monto
      }
    },
    async getUserInfo() {
      //get info user from auth
      await auth
        .userInfo()
        .then((res) => {
          this.user = res.data;
          this.setProductos();
          let dataUser = {
            tipo: this.user.b_empresa || 0,
            creditos: this.user.monto_creditos || -1,
            capital: this.user.monto_capital || -1,
            campania: this.user.b_campania || 0
          };
          this.setPublicidades({ user: dataUser, mostrar: false });
        })
        .catch((error) => console.error(error));
    }
  },

  computed: {
    ...mapState([
      "dialogoCampania",
      "dialogoMora",
      "dialogoPublicidades",
      "publicidadesSlider",
      "dialogoMoraAvalado"
    ]),
    sameEmail() {
      let personal = this.user.email_persona;
      let notificaciones = this.user.email;
      return (
        funciones.validateEmail(personal) &&
        funciones.validateEmail(notificaciones) &&
        personal === notificaciones
      );
    },
    userLogged() {
      return auth.getUserLogged();
    },
    conv() {
      return conv;
    },
    func() {
      return funciones;
    },
    height() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 150;
        case "sm":
          return 100;
        case "md":
          return 50;
        case "lg":
          return 50;
        case "xl":
          return 50;
        default:
          return 50;
      }
    }
  },
  async mounted() {
    if (process.env.NODE_ENV !== "production") console.log(this.userLogged);
    this.loading = true;
    await this.getUserInfo();
    this.loading = false;
  }
};
</script>

<style scoped lang="css">
.titulo {
  font-size: 3.2vh;
  line-height: 40px;
  word-break: normal;
  font-weight: 300;
  white-space: normal;
}
.cabecera {
  color: white;
  font-weight: 300;
  font-size: 2.5vh;
  line-height: 3vh;
}
.productos {
  color: black;
  font-weight: 300;
  font-size: 2.5vh;
  line-height: 3vh;
}
</style>
